// Angular
import { computed, Injectable, signal } from '@angular/core';

// App types
import { SidebarMenuGroupVM } from '@app/core/types/sidebar-menu-group.interface';


@Injectable()
export class SidebarMenuService {
  private _groups = signal<SidebarMenuGroupVM[]>([]);
  groups = this._groups.asReadonly();

  visibleGroups = computed(() => {
    const groups = this._groups();

    return groups
      .filter(g => g.canView !== false)
      .map(g => ({
        ...g,
        items: g.items.filter(i => i.canView !== false),
      }))
      .filter(g => g.items.length > 0);
  });

  setStatic(groups: SidebarMenuGroupVM[]) {
    this._groups.set(groups);
  }

  patch(patcher: (current: SidebarMenuGroupVM[]) => SidebarMenuGroupVM[]) {
    this._groups.update(patcher);
  }

  setGroupPermission(groupId: string, canView: boolean) {
    this._groups.update(groups =>
      groups.map(g => (g.id === groupId ? { ...g, canView } : g))
    );
  }

  setItemPermission(itemId: string, canView: boolean) {
    this._groups.update(groups =>
      groups.map(g => ({
        ...g,
        items: g.items.map(i => (i.id === itemId ? { ...i, canView } : i)),
      }))
    );
  }
}
